import Loadable from "app/components/Loadable";
import { lazy } from "react";

const TerritoryList = Loadable(lazy(() => import("./TerritoryList")));
const TerritoryForm = Loadable(lazy(() => import("./TerritoryForm")));

const territoryRoutes = [
  {
    path: "/Territory/TerritoryList",
    element: <TerritoryList />,
  },
  {
    path: "/Territory/TerritoryForm",
    element: <TerritoryForm />,
  },
  {
    path: "/Territory/TerritoryForm/:territoryId",
    element: <TerritoryForm />,
  },
];

export default territoryRoutes;
